import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { InvitationLegacyGuardService } from '@main-client/src/app/invite-members/invitation-legacy-guard.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: ':inviteCode',
        children: [],
        canActivate: [InvitationLegacyGuardService],
        data: {
          isEmptyState: true,
        },
      },
    ]),
  ],
  providers: [InvitationLegacyGuardService],
})
export class InvitationModule {}
